import { Box, type BoxProps } from "@chakra-ui/react";
import React from "react";

export function VideoWrapper({ children, ...props }: BoxProps) {
  return (
    <Box
      border="1px"
      borderColor="brand.border.extraLight"
      borderRadius={{ base: "small", md: "big" }}
      mt={{ base: "bigger", md: "biggest" }}
      maxW="5xl"
      mx="auto"
      overflow="hidden"
      {...props}
    >
      {children}
    </Box>
  );
}
